
export enum PersonaSize {
  XXSmall = '2xSmall',
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  XSmall = 'xSmall',
}
type TEm = `${number}em` | `${number}rem`

type TSizeDictionary = Record<PersonaSize, TEm>

export const AVATAR_SIZE: TSizeDictionary = {
  '2xSmall': '2.2em',
  xSmall: '2.5em',
  small: '3.5em',
  medium: '6em',
  large: '10em',
}

const ONLINE_BADGE_SIZE: TSizeDictionary = {
  '2xSmall': '0.5em',
  xSmall: '0.75rem',
  small: '1.1em',
  medium: '1.25em',
  large: '1.5em',
}

// We need to adjust the AvatarBadge component which doesn't scale correctly
// by default.
const ONLINE_BADGE_MARGIN: TSizeDictionary = {
  '2xSmall': '0em',
  xSmall: '0.125rem',
  small: '0.2em',
  medium: '0.4em',
  large: '0.85em',
}

const ONLINE_BADGE_BORDER: TSizeDictionary = {
  '2xSmall': '0em',
  xSmall: '0.125rem',
  small: '0.2em',
  medium: '0.4em',
  large: '0.85em',
}

const HORIZONTAL_SPACING: TSizeDictionary = {
  '2xSmall': '0.5em',
  xSmall: '0.5rem',
  small: '1em',
  medium: '1.2em',
  large: '1.4em',
}

export const VERTICAL_SPACING: TSizeDictionary = {
  '2xSmall': '0em',
  xSmall: '0.1em',
  small: '0.3em',
  medium: '1em',
  large: '1em',
}

export const TITLE_FONT_WEIGHT = {
  '2xSmall': '500',
  xSmall: '500',
  small: '500',
  medium: '500',
  large: '700',
}

export const SELECTION_WIDTH: `${string}px` = '3px'

export const getAvatarSize = (size: PersonaSize): TEm => AVATAR_SIZE[size]

export const getAvailabilityBadgeMargin = (
  size: PersonaSize,
  isSelected?: boolean,
): string =>
  `calc(${ONLINE_BADGE_MARGIN[size]} - ${isSelected ? SELECTION_WIDTH : '0px'})`

export const getAvailabilityBadgeSize = (size: PersonaSize): TEm =>
  ONLINE_BADGE_SIZE[size]

export const getAvailabilityBadgeBorder = (size: PersonaSize): TEm =>
  ONLINE_BADGE_BORDER[size]

export const getHorizontalSpacing = (size: PersonaSize): TEm =>
  HORIZONTAL_SPACING[size]

export const getVerticalSpacing = (size: PersonaSize): TEm =>
  VERTICAL_SPACING[size]

export const getTitleFontWeight = (size: PersonaSize): string =>
  TITLE_FONT_WEIGHT[size]
